/*
 *  Copyright (c) Qwoach LLC 2020. All rights reserved.
 *  Unauthorized copying of this file, via any medium is strictly prohibited
 *  Proprietary and confidential
 *  Created by Artem Bogush <artem@qwoach.com> on 4/11/2020
 */

import {AnalyticsManager,
	AmplitudeAnalytics,
	MixpanelAnalytics,
	GA4Analytics } from "@qwoach/analytics"

import {isDevEnv} from "@/utils/runtimeHelpers";
import EnchargeAnalytics from "@/core/analytic/EnchargeAnalytics";

let settingsAmplitude = {}
let settingsMixpanel = {}
let settingsGa4 = {}

let amplitudeServerZone = process.env.VUE_APP_ANALYTICS_AMPLITUDE_SERVER_ZONE || "US"
let amplitudeProxyPath = "/api/an/am"

if(amplitudeServerZone === "EU"){
	amplitudeProxyPath = "/api/an/eu/am"
}

settingsAmplitude = {
	serverUrl: `${process.env.VUE_APP_PROXY_DOMAIN}${amplitudeProxyPath}`,
	serverZone: amplitudeServerZone
}

settingsMixpanel = {
	api_host: `${process.env.VUE_APP_PROXY_DOMAIN}/api/an/mp`,
	api_routes: {
		track: `tr`,    // https://proxy.qwoach.com/api/an/mp/tr
		engage: `en`,   // https://proxy.qwoach.com/api/an/mp/en
		groups: `gr`,   // https://proxy.qwoach.com/api/an/mp/gr
	},
}

export default class QwoachAnalyticsManager extends AnalyticsManager {

	constructor(options = {}) {
		super([
			new AmplitudeAnalytics(process.env.VUE_APP_ANALYTICS_AMPLITUDE_API_KEY, {debug: false, ...settingsAmplitude, ...options.amplitude}),//debug:true clutters logs too much
			new MixpanelAnalytics(process.env.VUE_APP_ANALYTICS_MIXPANEL_API_KEY, {debug: isDevEnv, ...settingsMixpanel}),
			new GA4Analytics(process.env.VUE_APP_ANALYTICS_GA4_API_KEY, process.env.VUE_APP_ANALYTICS_GA4_SECRET, {debug: isDevEnv, ...settingsGa4}),
			// new GA4Analytics(process.env.VUE_APP_ANALYTICS_GOOGLE_UA_API_KEY, "no-key", {debug: isDevEnv}), //possible cause for duplicate events in GA4 account (why exactly?)
			new EnchargeAnalytics(process.env.VUE_APP_ANALYTICS_ENCHARGE_API_KEY, process.env.VUE_APP_ANALYTICS_ENCHARGE_WRITE_KEY, {debug: isDevEnv, ...options.encharge}),
		])
	}

	getUserIdInternal() {
		let props = this.client._metadataStorage.load()
		console.log("props = ", props)
		return this.client.getUserId()
	}

	getAmplitudeAnalytics(){
		return this.analyticsList[0].client
	}

	getAmplitudeUserId(){
		try {
			// let amplitudeAnalytics = this.analyticsList[0]
			// let props = amplitudeAnalytics.client._metadataStorage.load()
			// console.log("amplitudeUserId getAmplitudeUserId: props = ", props)
			// let identity = amplitudeAnalytics.client
			// console.log("amplitudeUserId identity = ", identity)

			return this.getAmplitudeAnalytics().getUserId()
		} catch (error){
			console.log(error)
			return null
		}
	}

	getAmplitudeSessionId(){
		try {
			return this.getAmplitudeAnalytics().getSessionId()
		} catch (error){
			console.log(error)
			return null
		}
	}

	getAmplitudeDeviceId(){
		try {
			return this.getAmplitudeAnalytics().getDeviceId()
		} catch (error){
			console.log(error)
			return null
		}

	}

	setUserEmail(email){
		if(!email){
			return
		}

		this.enumerateInstalledModules(analytics => {
			if(typeof analytics.setEmail === "function"){
				analytics.setEmail(email)
			}
		})
	}

	async trackPageView(props) {
		return super.trackPageView(props)
	}

	async setUserProps(props) {
		return super.setUserProps(props)
	}

	async setUserPropsOnce(props){
		return super.setUserPropsOnce(props)
	}
	async trackAppEntry(props){
		return super.trackAppEntry(props)
	}

	async setCohortVisitParams(){
		return super.setCohortVisitParams()
	}

	trackEvent(eventName, props) {
		return super.trackEvent(eventName, props)
	}

	async trackHoverEvent(element, eventName, props, triggerDelay) {
		return super.trackHoverEvent(element, eventName, props, triggerDelay)
	}

	async trackUrlParams() {
		return super.trackUrlParams()
	}

}
